import { getFolderViewStates } from './folderViewStatesActions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { loadFoldersFromSessionData, initializeArchiveMailboxFromSessionData, initializeSharedFolderRoots, } from 'owa-folders';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import setFolderViewState from 'owa-mail-folder-store/lib/actions/setFolderViewState';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
function isFolderExpanded(parsedFolderViewStates, folderId) {
    if (folderId == folderNameToId('msgfolderroot')) {
        // If the folder is the root folder, use UserOptions.IsMailRootFolderTreeCollapsed.
        return !getUserConfiguration().UserOptions.IsMailRootFolderTreeCollapsed;
    }
    else {
        // If we do not have a viewstate for this folder consider it expanded.
        var folderViewState = parsedFolderViewStates[folderId];
        return !folderViewState || folderViewState.IsExpanded;
    }
}
function initializeMailFolderViewStates() {
    var sessionDataViewStates = getFolderViewStates();
    Object.keys(sessionDataViewStates).forEach(function (folderId) {
        var mailFolderViewState = {
            isExpanded: isFolderExpanded(sessionDataViewStates, folderId),
            drag: createDragViewState(),
            drop: createDropViewState(),
        };
        setFolderViewState(folderId, mailFolderViewState);
    });
}
export default function loadMailFolders() {
    // populate folder store
    loadFoldersFromSessionData();
    // raise an action to initialize archive mailbox.
    if (isControlFeatureEnabled('tri-archive-mailbox')) {
        initializeArchiveMailboxFromSessionData();
    }
    // initialize shared folders
    if (isMailFeatureEnabled('tri-sharedFolders')) {
        setTimeout(function () { return initializeSharedFolderRoots(); }, 3000);
    }
    initializeMailFolderViewStates();
}
//# sourceMappingURL=loadMailFolders.js.map